export const GET_MCC = "GET_MCC"
export const GET_MCC_SUCCESS = "GET_MCC_SUCCESS"
export const GET_MCC_FAIL = "GET_MCC_FAIL"

export const GET_RANGE_ISO = "GET_RANGE_ISO "
export const GET_RANGE_ISO_SUCCESS = "GET_RANGE_ISO _SUCCESS"
export const GET_RANGE_ISO_FAIL = "GET_RANGE_ISO _FAIL"

export const GET_MCC_MASTERCARD_SERVİCE_CATEGORY = "GET_MCC_MASTERCARD_SERVİCE_CATEGORY"
export const GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS = "GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS"
export const GET_MCC_MASTERCARD_SERVİCE_CATEGORY_FAIL = "GET_MCC_MASTERCARD_SERVİCE_CATEGORY_FAIL"

export const GET_VISA_SERVICE_CATEGORY = "GET_VISA_SERVICE_CATEGORY"
export const GET_VISA_SERVICE_CATEGORY_SUCCESS = "GET_VISA_SERVICE_CATEGORY_SUCCESS"
export const GET_VISA_SERVICE_CATEGORY_FAIL = "GET_VISA_SERVICE_CATEGORY_FAIL"

export const GET_MCC_NATIONAL_SWITCH_CATEGORY = "GET_MCC_NATIONAL_SWITCH_CATEGORY"
export const GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS = "GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS"
export const GET_MCC_NATIONAL_SWITCH_CATEGORY_FAIL = "GET_MCC_NATIONAL_SWITCH_CATEGORY_FAIL"

export const GET_MCC_GEOGRAPHY_TYPE = "GET_MCC_GEOGRAPHY_TYPE"
export const GET_MCC_GEOGRAPHY_TYPE_SUCCESS = "GET_MCC_GEOGRAPHY_TYPE_SUCCESS"
export const GET_MCC_GEOGRAPHY_TYPE_FAIL = "GET_MCC_GEOGRAPHY_TYPE_FAIL"

export const ADD_MCC = "ADD_MCC"
export const ADD_MCC_SUCCESS = "ADD_MCC_SUCCESS"
export const ADD_MCC_FAIL = "ADD_MCC_FAIL"

export const UPDATE_MCC = "UPDATE_MCC"
export const UPDATE_MCC_SUCCESS = "UPDATE_MCC_SUCCESS"
export const UPDATE_MCC_FAIL = "UPDATE_MCC_FAIL"

export const DELETE_MCC = "DELETE_MCC"
export const DELETE_MCC_SUCCESS = "DELETE_MCC_SUCCESS"
export const DELETE_MCC_FAIL = "DELETE_MCC_FAIL"

export const MCC_API_ERROR = "API_ERROR"
